import { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { HeaderContext } from '../../Utils/HeaderContentProvider'

const CustomHeader = ({ title, subtitle, width, isFixed = false, children }) => {
  const dispatch = useDispatch()

  const { set } = useContext(HeaderContext)

  useEffect(() => {
    if (children) {
      set(children)
    }

    return () => set('')
  }, [children, set])

  useEffect(() => {
    const payload = {}

    if (title) {
      payload.title = title
    }

    if (subtitle) {
      payload.subtitle = subtitle
    }

    if (width) {
      payload.width = width
    }

    payload.isFixed = isFixed

    dispatch({
      type: 'UPDATE_HEADER_TITLES',
      payload
    })

    return () => {
      dispatch({
        type: 'CLEAR_HEADER_TITLES'
      })
    }
  }, [title, subtitle, width, dispatch, isFixed])

  return null
}

export default CustomHeader
